'use client';

import React, { useState } from 'react';

interface FooterClientProps {
  copyrightYear: number;
}

export const FooterClient = ({ copyrightYear }: FooterClientProps) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const toggleDisclaimer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowDisclaimer(!showDisclaimer);
  };

  const linkClassName =
    'text-[#4A4BB6] underline-offset-4 transition-colors hover:text-[#3a3b9c] hover:underline';

  return (
    <footer className="mt-auto w-full pb-2 pt-6 text-sm leading-[1.2rem] text-gray-500">
      <div className="max-w-7xl mx-auto px-4">
        <ul className="footer__links flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-normal">
          <li className="footer__link">
            <a
              href="#"
              className={`disclaimer-link cursor-pointer ${linkClassName}`}
              role="button"
              aria-expanded={showDisclaimer}
              onClick={toggleDisclaimer}
            >
              {showDisclaimer ? 'Hide' : 'Show'} Disclaimer
            </a>
          </li>
          <li className="footer__link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.varsitytutors.com/privacy"
              className={linkClassName}
            >
              Privacy Policy
            </a>
          </li>
          <li className="footer__link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.varsitytutors.com/terms-of-use"
              className={linkClassName}
            >
              Terms of Use
            </a>
          </li>
          <li className="footer__link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.varsitytutors.com/accessibility"
              className={linkClassName}
            >
              Accessibility
            </a>
          </li>
        </ul>

        <div className="footer__copyright mt-4 text-center" style={{ fontSize: '11px' }}>
          Varsity Tutors ©2007-{copyrightYear}. All rights reserved.
        </div>
        
        <div 
          className={`collapsible-section collapsible-section--disclaimers ${showDisclaimer ? 'is-open mt-4' : ''}`}
          aria-hidden={!showDisclaimer}
        >
        <div className="
      transform transition-transform duration-500 ease-in-out leading-relaxed text-center
      translate-y-0 text-gray-500
    " style={{ fontSize: '11px' }}>
      <p className="inline">Names of standardized tests are owned by the trademark holders and are not affiliated with Varsity Tutors LLC.</p>
      <p className="inline before:content-['•'] before:mx-2">Media outlet trademarks are owned by the respective media outlets and are not affiliated with Varsity Tutors.</p>
      <p className="inline before:content-['•'] before:mx-2">Award-Winning claim based on CBS Local and Houston Press awards.</p>
      <p className="inline before:content-['•'] before:mx-2">Varsity Tutors does not have affiliation with universities mentioned on its website.</p>
      <p className="inline before:content-['•'] before:mx-2">Varsity Tutors connects learners with a variety of experts and professionals.</p>
      <p className="inline before:content-['•'] before:mx-2">Tutors, instructors, experts, educators, and other professionals on the platform are independent contractors, who use their own styles, methods, and materials and create their own lesson plans based upon their experience, professional judgment, and the learners with whom they engage.</p>
      <p className="inline before:content-['•'] before:mx-2">¹ Lee, J.Y. (2013). "Private tutoring and its impact on students' academic achievement, formal schooling, and educational inequality in Korea." Unpublished doctoral thesis. Columbia University.</p>
      <p className="inline before:content-['•'] before:mx-2">
        <a 
          className="privacy_link hover:text-gray-400 transition-colors" 
          href="https://www.varsitytutors.com/cookie-list" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Click for more information on your privacy rights.
        </a>
      </p>
    </div>
        </div>
      </div>
    </footer>
  );
};
